const log_details = {
    page_title: 'รายละเอียดบันทึกการตรวจสอบ',
    back_to_logs: 'กลับไปที่บันทึกการตรวจสอบ',
    back_to: 'กลับไปที่ {{name}}',
    success: 'สำเร็จ',
    failed: 'ล้มเหลว',
    event_key: 'รหัสเหตุการณ์',
    application: 'แอปพลิเคชัน',
    ip_address: 'ที่อยู่ IP',
    user: 'ผู้ใช้',
    log_id: 'รหัสบันทึก',
    time: 'เวลา',
    user_agent: 'User agent',
    tab_details: 'รายละเอียด',
    raw_data: 'ข้อมูลดิบ',
};
export default Object.freeze(log_details);
